import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '100%',
  gap: (p) => p.spacing(1),
  overflow: 'visible',
};

export const icon: SxStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  margin: 'auto',
  pl: (p) => p.spacing(1),
  color: (p) => p.palette.common.black,
  zIndex: 9,
};

export const errorText: SxStyle = {
  color: (p) => p.palette.error[500],
  fontSize: (p) => p.typography.caption,
};

export const errorIcon: SxStyle = {
  color: (p) => p.palette.error[500],
};
